import { ReactNode, RefCallback, useCallback } from "react"
import { useToggle } from "react-use"
import cn from "classnames"

import { Spinner } from "components/Spinner"
import { OWNER } from "modules/Call/common/constants"
import { useHandleError } from "modules/Call/common/hooks"
import { VideoControls } from "modules/Call/components/VideoControls"
import { useInitCallProvider } from "modules/Call/components/InitCallProvider"

interface Props {
    avatar: ReactNode
    voximplantUserName: string
    generateTokenApiUrl: string
    owner: OWNER
    bookingHash: string
}

export function LobbyVideo({
    avatar,
    voximplantUserName,
    generateTokenApiUrl,
    owner,
    bookingHash,
}: Props) {
    const [state, { init }] = useInitCallProvider()
    const [isOpenedHelpModal, toggleIsOpenedHelpModal] = useToggle(false)

    const onRender = useCallback<RefCallback<HTMLDivElement>>((instance) => {
        if (instance) {
            void init(instance, voximplantUserName, generateTokenApiUrl, owner, bookingHash)
        }
    }, [])

    useHandleError(state.error)

    return (
        <>
            <div className="is-relative">
                <div
                    ref={onRender}
                    id="local-video-container"
                    className={cn(
                        "video-container",
                        "video-container__mirror",
                        "video-container__round-corners",
                        "is-lobby",
                        {
                            "video-container__is-loading": !state.ready,
                        }
                    )}
                />
                {!state.ready ? <Spinner className="video-spinner" /> : avatar}
                {state.ready && (
                    <VideoControls
                        isOpenedHelpModal={isOpenedHelpModal}
                        toggleIsOpenedHelpModal={toggleIsOpenedHelpModal}
                    />
                )}
            </div>
        </>
    )
}
